import { render, staticRenderFns } from "./SocChart.vue?vue&type=template&id=1163022e&scoped=true&"
import script from "./SocChart.vue?vue&type=script&lang=js&"
export * from "./SocChart.vue?vue&type=script&lang=js&"
import style0 from "./SocChart.vue?vue&type=style&index=0&id=1163022e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1163022e",
  null
  
)

export default component.exports